import React, { FC } from 'react';
import { View, Text } from 'react-native';

import { scale } from '@components/frame';

import { font } from '@styles/fonts';
import i18n from 'i18n-js';
import { ColorFunction } from '@styles/colors/types';
import { DataBarItem } from '@components/machines/components/eventsChart/types';
import { ScaleFunction } from '@components/operatorPanel/interfaces';
import { ContainerStyle } from '@interfaces/base';

interface ChartLegendsProps extends ContainerStyle {
  legendsWidth: number;
  chartHeight: number;
  isDay: boolean;
  C: ColorFunction;
  heightValues: string[];
  dataBar: DataBarItem[];
  legendVerticalOffsets?: {
    top: number;
    middle: number;
    bottom: number;
  } 
}

const ChartLegends: FC<ChartLegendsProps> = ({ chartHeight, legendsWidth, C, isDay, heightValues, dataBar, containerStyle, legendVerticalOffsets }) => {
  const formatLegend = (v: number) => (isDay ? `${v * 60}${i18n.t('m')}` : `${v}${i18n.t('h')}`);

  const scaleFn = scale as ScaleFunction;

  const hourInSeconds = 60 * 60;

  let formattedData = dataBar.map((item) => ({
    ...item,
    total: heightValues.reduce((a: number, key) => {
      return (item[key] as number) + a;
    }, 0),
  }));

  const maxValue = formattedData ? Math.max(...formattedData?.map((i) => i.total)) : 0;

  const rightLegend = (() => {
    const hours = Math.ceil(maxValue / hourInSeconds);
    if (hours <= 1 && isDay) return [0, 0.5, 1];
    if (hours <= 2) return [0, 1, 2];
    if (hours <= 4) return [0, 2, 4];
    if (hours <= 6) return [0, 3, 6];
    if (hours <= 12) return [0, 6, 12];
    if (hours <= 18) return [0, 9, 18];
    if (hours <= 24) return [0, 12, 24];

    return [0, Math.round(hours / 2), hours];
  })();

  return (
    <View
      style={[
        {
          // top: scaleFn(4),
          // right: 0,
          height: chartHeight,
          width: legendsWidth,
        },
        containerStyle,
      ]}
    >
      <View style={{ position: 'absolute', top: -scaleFn(legendVerticalOffsets?.top ?? 8, false), left: scaleFn(6) }}>
        <Text style={[font['Footnote'], { color: C('Label/Light/Quaternary') }]}>{formatLegend(rightLegend[2])}</Text>
      </View>
      <View style={{ position: 'absolute', top: chartHeight / 2 - scaleFn(legendVerticalOffsets?.middle ?? 9, false), left: scaleFn(6) }}>
        <Text style={[font['Footnote'], { color: C('Label/Light/Quaternary') }]}>{formatLegend(rightLegend[1])}</Text>
      </View>
      <View style={{ position: 'absolute', bottom: -scaleFn(legendVerticalOffsets?.bottom ?? 9, false), left: scaleFn(6) }}>
        <Text style={[font['Footnote'], { color: C('Label/Light/Quaternary') }]}>{formatLegend(rightLegend[0])}</Text>
      </View>
    </View>
  );
};

export default ChartLegends;
